module.exports = __webpack_public_path__ + "img/20190704161657719.32d6881a.png";